import React from "react";
import type { IconProps } from "./types";

/**
 * PencilIcon component that renders a pencil icon SVG
 * @param props - The component props
 * @param props.className - CSS class name for styling
 * @param props.width - Width of the icon (default: 12)
 * @param props.height - Height of the icon (default: 12)
 * @returns The rendered pencil icon component
 */
const PencilIcon: React.FC<IconProps> = ({ className, width = 12, height = 12 }) => {
  return (
    <svg
      viewBox="-0.25 -0.25 12 12"
      xmlns="http://www.w3.org/2000/svg"
      id="Pencil--Streamline-Ultimate"
      height={height}
      width={width}
      className={className}
    >
      <desc>Pencil Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="m8.467698810406251 0.9996432689270833 2.03293199595 2.0329319959020835L3.2891433728479167 10.2440626983375l-2.0329319959020835 -2.0329319959020835z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M1.2558958333333334 8.211 0.23958333333333334 11.260416666666668l3.0494166666666667 -1.0163125 -2.033104166666667 -2.033104166666667z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="m10.500458333333334 3.032166666666667 -2.032625 -2.032625 0.33877083333333335 -0.33877083333333335a1.4375 1.4375 0 0 1 2.032625 2.032625Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default PencilIcon;
